import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { IContractorDetailsPayload, IContractorDetailsResponse } from '.';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';

interface IContractorDetails {
	mutate: UseMutateFunction<IContractorDetailsResponse, Error, IContractorDetailsPayload, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useContractorDetailsMutation = (): IContractorDetails => {
	const postContractorDetails = async (formData: IContractorDetailsPayload): Promise<IContractorDetailsResponse> => {
		return APIService.postData<IContractorDetailsResponse>(APICONFIG.SS_CONTRACTOR, formData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: postContractorDetails,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
